module.exports = __webpack_public_path__ + "img/partner_banner.1b934d3e.png";